import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=740e694b&scoped=true"
import script from "./Accounts.vue?vue&type=script&lang=js"
export * from "./Accounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e694b",
  null
  
)

export default component.exports